import styles from './index.module.scss';

const Spliter = () => {
    return (
        <div className={styles.previewSpliter}></div>
    );
};

export default Spliter;
